/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsAccountMetricsDestination } from '../models/AwsAccountMetricsDestination';

export class EnableRestoreAccountMetricsConfigRequest {
  'aws'?: AwsAccountMetricsDestination | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsAccountMetricsDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EnableRestoreAccountMetricsConfigRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

